import React from 'react';
import { Tooltip } from 'antd';
import RecurringIcon from "../../../../../../assets/icons/recurring.svg";
import GaIcon from "../../../../../../assets/icons/grant-agreement.svg";
import { UnderlyingContent, TableLabel } from '../../style';
import { formatAmount } from "../../../../../../utils/commonUtil";
import { recognitionType } from "../../utils";

const columns = (grantDetailsHandler) => [
  {
    title: "",
    dataIndex: "",
    key: "spawnType",
    render: (value, record) => {
      if (record.isRecurring) {
        return (
          <Tooltip placement="bottomLeft" title="Recurring Grant Schedule">
            <img className="pointer" src={RecurringIcon} alt="Recurring" />
          </Tooltip>
        );
      } else if (record.grantAgreement) {
        return (
          <Tooltip placement="bottomLeft" title="Grant Agreement">
            <img className="pointer" src={GaIcon} alt="Grant agreement" />
          </Tooltip>
        );
      }
    }
  },
  {
    title: 'Transaction ID',
    dataIndex: 'transactionId',
    key: 'transactionId',
    render: (value, record) => {
      return (<UnderlyingContent id={`anrTransactionID${record.transactionId}`} tableFont onClick={() => grantDetailsHandler(value, "single")}>{value}</UnderlyingContent>);
    },
  }, {
    title: 'Entered Date',
    dataIndex: 'receiveDate',
    key: 'receiveDate',
    render: value => (<TableLabel tableFont>{value}</TableLabel>),
  }, {
    title: 'Amount',
    dataIndex: 'grantAmount',
    key: 'grantAmount',
    render: value => (<TableLabel tableFont>{formatAmount(value)}</TableLabel>),
  }, {
    title: 'Purpose',
    dataIndex: 'grantPurpose',
    key: 'grantPurpose',
    render: value => (<TableLabel tableFont>{value}</TableLabel>),
  }, {
    title: 'Recognition',
    dataIndex: 'recognitionOptions',
    key: 'recognitionOptions',
    render: value => (<TableLabel tableFont>{value.recognitionId && recognitionType[value.recognitionId]}</TableLabel>),
  }, {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: value => (<TableLabel tableFont>{value}</TableLabel>),
  }
];

export default columns;
